import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shallowCamelCase',
  standalone: true
})
export class ShallowCamelCasePipe implements PipeTransform {
  transform<T extends Record<string, unknown>>(obj: T): T;
  transform(obj: null | undefined): null | undefined;
  transform(obj: unknown): unknown;
  transform(obj: unknown): unknown {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
      return obj;
    }

    const result: Record<string, unknown> = {};
    
    for (const [key, value] of Object.entries(obj)) {
      const camelCaseKey = this.toCamelCase(key);
      result[camelCaseKey] = value; // Keep the value as-is (no deep conversion)
    }

    return result as typeof obj;
  }

  private toCamelCase(str: string): string {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  }
}